import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { PagetitleComponent } from './pagetitle/pagetitle.component';
import { UserModalComponent } from './user-modal/user-modal.component';
import { NotificationComponent } from './notification/notification.component';
import {MessagesModule} from 'primeng/messages';
import {MessageModule} from 'primeng/message';
import {MultiSelectModule} from 'primeng/multiselect';
import { FormsModule } from '@angular/forms';
import {CheckboxModule} from 'primeng/checkbox';
import { ReactiveFormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { helperService } from '../utils/helper';
import { ConfirmationAlertComponent } from './confirmation-alert/confirmation-alert.component';
import { DialogModule } from 'primeng/dialog';

// Feature modules
import { NotificationsModule } from '../features/notifications/notifications.module';
import { InfoTooltipComponent } from './info-tooltip/info-tooltip.component';

// Spell Check
import { SpellCheckDirective } from './directives/spell-check.directive';
import { StaticMultiValueComponent } from './components/static-multi-value/static-multi-value.component';
import { SpellCheckSuggestionComponent } from './components/spell-check-suggestion/spell-check-suggestion.component';
import { SpellCheckService } from './services/spell-check.service';
import { FormatDatePipe } from './components/pipes/format-date.pipe';

@NgModule({
    declarations: [
        PagetitleComponent,
        UserModalComponent,
        NotificationComponent,
        ConfirmationAlertComponent,
        InfoTooltipComponent,
        SpellCheckDirective,
        StaticMultiValueComponent,
        SpellCheckSuggestionComponent,
        FormatDatePipe
    ],
    imports: [
        CommonModule,
        MessagesModule,
        MessageModule,
        MultiSelectModule,
        FormsModule,
        CheckboxModule,
        ReactiveFormsModule,
        DialogModule,
        NotificationsModule
    ],
    providers: [MessageService, helperService, SpellCheckService, DatePipe],
    exports: [
        PagetitleComponent,
        UserModalComponent,
        NotificationComponent,
        ConfirmationAlertComponent,
        NotificationsModule,
        InfoTooltipComponent,
        SpellCheckDirective,
        StaticMultiValueComponent,
        SpellCheckSuggestionComponent,
        FormatDatePipe
    ]
})
export class SharedModule { }
